export interface IPesquisaPerfis {
    id: number,
    nome: string,
    parametros_obrigatorios?: string[] | null
}

export const defValuePerfil: IPesquisaPerfis = {
    id: 0,
    nome: ""
}